<div class="w-full">
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
    {{ label }}
  </label>
  <div class="relative z-20 inline-block w-full">
    <div class="relative flex flex-col items-center">
      <div (click)="toggleDropdown()" class="w-full">
        <div class="mb-2 flex h-11 rounded-lg border border-gray-300 py-1.5 pl-3 pr-3 shadow-theme-xs outline-hidden transition focus:border-brand-300 focus:shadow-focus-ring dark:border-gray-700 dark:bg-gray-900 dark:focus:border-brand-300">
          <div class="flex flex-wrap flex-auto gap-2">
            @if (selectedValuesText.length > 0) {
              @for (text of selectedValuesText; track $index; let i = $index) {
              <div
                class="group flex items-center justify-center rounded-full border-[0.7px] border-transparent bg-gray-100 py-1 pl-2.5 pr-2 text-sm text-gray-800 hover:border-gray-200 dark:bg-gray-800 dark:text-white/90 dark:hover:border-gray-800"
              >
                <span class="flex-initial max-w-full">{{ text }}</span>
                <div class="flex flex-row-reverse flex-auto">
                  <div
                    (click)="removeOption(selectedOptions[i]); $event.stopPropagation()"
                    class="pl-2 text-gray-500 cursor-pointer group-hover:text-gray-400 dark:text-gray-400"
                  >
                    <svg class="fill-current" role="button" width="14" height="14" viewBox="0 0 14 14">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.40717 4.46881C3.11428 4.17591 3.11428 3.70104 3.40717 3.40815C3.70006 3.11525 4.17494 3.11525 4.46783 3.40815L6.99943 5.93975L9.53095 3.40822C9.82385 3.11533 10.2987 3.11533 10.5916 3.40822C10.8845 3.70112 10.8845 4.17599 10.5916 4.46888L8.06009 7.00041L10.5916 9.53193C10.8845 9.82482 10.8845 10.2997 10.5916 10.5926C10.2987 10.8855 9.82385 10.8855 9.53095 10.5926L6.99943 8.06107L4.46783 10.5927C4.17494 10.8856 3.70006 10.8856 3.40717 10.5927C3.11428 10.2998 3.11428 9.8249 3.40717 9.53201L5.93877 7.00041L3.40717 4.46881Z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              }
            } @else {
              <input
                placeholder="Select option"
                class="w-full h-full p-1 pr-2 text-sm bg-transparent border-0 outline-hidden appearance-none placeholder:text-gray-800 focus:border-0 focus:outline-hidden focus:ring-0 dark:placeholder:text-white/90"
                readonly
                value="Select option"
              />
            }
          </div>
          <div class="flex items-center py-1 pl-1 pr-1 w-7">
            <button
              type="button"
              (click)="toggleDropdown()"
              class="w-5 h-5 text-gray-700 outline-hidden cursor-pointer focus:outline-hidden dark:text-gray-400"
            >
              <svg
                class="stroke-current"
                [ngClass]="{ 'rotate-180': isOpen }"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M4.79175 7.39551L10.0001 12.6038L15.2084 7.39551"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
      @if (isOpen) {
      <div
        class="absolute left-0 z-40 w-full overflow-y-auto bg-white rounded-lg shadow-sm top-full max-h-select dark:bg-gray-900"
        (click)="$event.stopPropagation()"
      >
        <div class="flex flex-col">
          @for (option of options; track $index) {
          <div
            class="hover:bg-primary/5 w-full cursor-pointer rounded-t border-b border-gray-200 dark:border-gray-800"
            (click)="handleSelect(option.value)"
          >
            <div
              class="relative flex w-full items-center p-2 pl-2"
              [ngClass]="{ 'bg-primary/10': selectedOptions.includes(option.value) }"
            >
              <div class="mx-2 leading-6 text-gray-800 dark:text-white/90">
                {{ option.text }}
              </div>
            </div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
</div>